export default __webpack_public_path__ + "static/media/data-content.b5f44301.png";